export default __webpack_public_path__ + "static/media/lolo.792ce52b.png";